define([
	"dojo/_base/declare",
	"lodash",
	"csi/html",
	"csi/store/Cache",
	"csi/widget/_ComboBoxMenu",
	"csi/widget/MaterialIcon",
], function(declare, _, html, Cache, _ComboBoxMenu, MaterialIcon) {

	return declare(_ComboBoxMenu, {
		/** @property {Cache} cache */
		cache: null,

		/** throttled "get details" function */
		getItemDetailsThrottled: null,

		/** the node that was hovered - avoid recreating summary multiple time while on the same node */
		lastHoveredNode: null,

		/** @property {Object} previewWidgetParams - parameters to use when creating instance of preview widget, in addition to "item" from store */
		previewWidgetParams: null,

		/** @property {CustomViewSummaryItem} defaultSelectedItem - the item which is selected when control starts, default selected item */
		defaultSelectedItem: null,

		/**
		 * @override
		 */
		postCreate: function() {
			this.inherited(arguments);

			this.cache = new Cache();
			this.getItemDetailsThrottled = _.throttle((previewNode, item, params) => {
				const {urlNode} = item;
				item.getItemDetails(urlNode).then((itemDetails) => {
					html.clear(previewNode, true);
					const preview = new this.previewWidgetClass(Object.assign({item, itemDetails}, params))
					preview.placeAt(previewNode);
					preview.startup();
				});
			}, 500, {leading: false});
		},

		/**
		 * @override
		 * Ignore disabled items, and show preview if so configured
		 * @param {DOMNode} node
		 */
		onHover: function(node) {
			if (!this._isDisabledSelection(node)) {
				this.inherited(arguments);
				if (node != this.lastHoveredNode) {
					this.lastHoveredNode = node;
					this._showPreview(node);
				}
			}
		},

		/**
		 * @override
		 * Ignore disabled items, and show preview if so configured
		 */
		onSelect: function(node) {
			if (!this._isDisabledSelection(node)) {
				this.inherited(arguments);
				this._showPreview(node);
			}
			this.inherited(arguments);
		},

		/**
		 * @override
		 * Add custom class to menu items
		 */
		_createOption: function(item, labelFunc) {
			var menuitem = this.inherited(arguments);
			menuitem.style.display = "flex";

			menuitem.innerHTML = `<span class="csi-select-plugin-text">` + menuitem.innerHTML + `</span>`;

			if (item.getIcon) {
				menuitem.innerHTML = `<span class="material-icons csi-select-plugin-icon">${item.getIcon()}</span>` + menuitem.innerHTML;
			}

			if (item.setFavorite && !item.isDefaultView()) {
				const favIcon = new MaterialIcon({
					"class": "csi-select-plugin-favorite-icon" + (item.favorite ? " csi-select-favorite" : ""),
					icon: item.favorite ? "star" : "star_outline",
					onClick: item.setFavorite.bind(item),
					stopMouseUp: true,
				});
				menuitem.insertBefore(favIcon.domNode, null);
			}

			if (this.isSelectedFunc?.(item)) {
				this.defaultSelectedItem = item;
			}

			return menuitem;
		},

		/**
		 * Show preview for given node
		 * @param {DOMNode | null} node
		 * @param {CustomViewSummaryItem} [previewItem]
		 */
		_showPreview: function(node, previewItem) {
			const previewNode = this._previewNode;
			if (previewNode) {
				const item = previewItem || this.items[node.getAttribute("item")];
				const params = this.previewWidgetParams;

				if (item.getItemDetails) {
					const {itemDetails} = item;
					this.getItemDetailsThrottled.cancel();
					if (itemDetails) {
						html.clear(previewNode, true);
						new this.previewWidgetClass(Object.assign({item, itemDetails}, params))
							.placeAt(previewNode)
							.startup();
					} else {
						this.getItemDetailsThrottled(previewNode, item, params);
					}
				}
			}
		},

		/**
		 * @override
		 * show preview on dropdown open
		 */
		onOpen: function() {
			this.inherited(arguments);
			this._showPreview(null, this.defaultSelectedItem);
		}
	});
});